import React from 'react';
import PropTypes from 'prop-types';

const LeadPropsContext = React.createContext(undefined);

export function LeadPropsContextProvider({ children, email }) {
  return (
    <LeadPropsContext.Provider value={{ email }}>
      {children}
    </LeadPropsContext.Provider>
  );
}

LeadPropsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  email: PropTypes.string.isRequired,
};

export function useLeadPropsContext() {
  const context = React.useContext(LeadPropsContext);

  if (!context) {
    throw new Error(
      'useLeadPropsContext must be called from a PromoCodeInputFilledContext.Provider',
    );
  }

  return context;
}
